import { useContext } from 'react';
import { CheckoutConfirmationContext } from './checkoutConfirmationContext';

export const useCheckoutConfirmationContext = () => useContext(CheckoutConfirmationContext);
